<template>
  <div class="contact-box">
   <van-nav-bar
   :title="title"
   left-text="返回"
   left-arrow
   @click-left="onClickLeft"/>
  </div>
</template>

  <script>
  import { NavBar,Icon,Row, Col,DropdownMenu,DropdownItem} from 'vant';
  export default {
    props: ["title"],
    data() {
      return {};
      title:"";
    },
    components: {
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Row.name]: Row,
      [Col.name]: Col,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
    },
    
    methods: {
    go(pathName) {
      this.$router.push({ name: pathName });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    }
  };
  </script>

  <style lang="less" scoped>
   .van-nav-bar{border-bottom:none; height: 55px; line-height: 55px; position: fixed; top: 0; width: 100%;}
   .van-nav-bar__title{ line-height: 60px;}
   .van-nav-bar__title,.van-nav-bar__text{ color:#000 !important;}
   /deep/.van-nav-bar .van-icon::before{ display: block; margin-top: -4px; color:#333;}
   /deep/.van-dropdown-menu{ background:none;}
   /deep/.van-dropdown-menu__title{ color:#fff!important;}
   /deep/.van-dropdown-menu__title::after{ display:none;}
   .sign_out{ color:#fff;}
  </style>